export const HEADING_SIDE_TEST_ID =
	'atlassian-navigation.ui.settings.menu.home.heading.side-heading';
